import { surveyRepository } from '../repositories/survey-repository';

async function sendResults(body) {
    if (!body.email) {
        throw Error('Invalid parameters');
    }

    return surveyRepository.sendResults(body);
}

export {
    sendResults
};
